var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"le-content-loader"},[_c('div',{staticClass:"le-content-loader-inner"},[_c('div',{staticClass:"le-content-loader-spinner"}),_c('img',{attrs:{"src":_vm.LeLogo,"alt":_vm.LeLogo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }